export const ReviewerTypes = {
  HOST: 'host',
  GUEST: 'guest',
  ATTENDEE: 'attendee',
};

export const ReviewTabs = {
  ABOUT_YOU: 'about-you',
  ABOUT_SPACES: 'about-spaces',
  BY_YOU: 'by-you',
};

export const REVIEWS_PER_PAGE = 10;

export const getReviewerName = (review, intl) => {
  if (review.imported_rawReview) {
    const firstName = review.imported_rawReview.firstName;
    const lastName = review.imported_rawReview.lastName.charAt(0) + '.';
    return `${firstName} ${lastName}`;
  }

  let nameObj;
  if (review.reviewer_type === ReviewerTypes.HOST) {
    nameObj = review.host?.name;
  }
  if (review.reviewer_type === ReviewerTypes.GUEST) {
    nameObj = review.guest?.name;
  }
  if (review.reviewer_type === ReviewerTypes.ATTENDEE) {
    nameObj = review.reviewer_name;
  }
  if (nameObj) {
    return `${nameObj.first} ${nameObj.last}`;
  }
  return intl.formatMessage({
    id: 'reviews.reviewer_name.someone',
    defaultMessage: 'Someone',
  });
};

export const getReviewDate = (review) => {
  if (review.imported_rawReview) {
    return review.imported_rawReview.timestamp;
  }
  return review.date_created;
};
